import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideRouter, withPreloading } from '@angular/router';
import { CustomPreloadingStrategy, provideBfyUiShared, Site } from '@bfy/bfy-ui-shared';
import { provideToastr } from '@iqx-limited/ngx-toastr';
import { appRoutes } from './app.routing';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: APP_BASE_HREF,
            useFactory: () => (!isDevMode() ? '/' : '/root/'),
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' },
        },
        {
            provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
            useValue: { hideSingleSelectionIndicator: true },
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideToastr({
            disableTimeOut: 'extendedTimeOut',
            closeButton: true,
            enableHtml: true,
            // XXX: ngx-toastr uses the same icons by default except they have the check without the circle, but iconClasses
            // works differently in ngx-toastr than it did in angular2-toaster, so commenting out for now
            // iconClasses: {
            //     error: 'fa fa-exclamation-circle',
            //     info: 'fa fa-info-circle',
            //     success: 'fa fa-check-circle',
            //     warning: 'fa fa-exclamation-triangle'
            // }
        }),
        provideBfyUiShared({
            site: Site.Root,
        }),
        provideRouter(appRoutes, withPreloading(CustomPreloadingStrategy)),
        provideLuxonDateAdapter(),
    ],
};
